import { render, staticRenderFns } from "./SysAppRelateTransfer.vue?vue&type=template&id=c686dbee&scoped=true&"
import script from "./SysAppRelateTransfer.vue?vue&type=script&lang=js&"
export * from "./SysAppRelateTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SysAppRelateTransfer.vue?vue&type=style&index=0&id=c686dbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c686dbee",
  null
  
)

export default component.exports